// export const SET_CURRENT_TASK = `${MODULE_NAME}/SET_CURRENT_TASK`;

export const LOCAL_SET_DOCUMENTS = 'LOCAL_SET_DOCUMENTS';
export const LOCAL_ADD_DOCUMENT = 'LOCAL_ADD_DOCUMENT';
export const LOCAL_RENAME_DOCUMENT = 'LOCAL_RENAME_DOCUMENT';
export const LOCAL_DELETE_DOCUMENT = 'LOCAL_DELETE_DOCUMENT';
export const LOCAL_MOVE_DOCUMENTS = 'LOCAL_MOVE_DOCUMENTS';
